import React from 'react';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import BookItem from '../book/bookItem';
import DownloadVersion from '../../containers/content/downloadVersion';

export const ReceivedManuscriptsTabPane = ({ submissions, t }) => (
  <div className='submitted-manuscripts'>
      {
        submissions.length > 0 && submissions.map((submission) => {
          if (submission.book) {
            return (
              <React.Fragment key={submission.book._id}>
                <BookItem key={submission.createdAt} book={submission.book} />
                <p style={{ marginBottom: 10 }}>
                  {t('SubmittedBy', { _userName: submission.createdBy?.displayName })}
                  <span style={{marginLeft: 8, color: 'var(--br-muted)'}}>
                    {moment(submission.createdAt).format('L LTS')}
                  </span>
                </p>
                { submission.ranking && submission.ranking.eligibleForValentineCrime && (
                  <p style={{marginBottom: 10, color: 'var(--br-success-text)'}}>
                    Valentine Crime Approved
                  </p>
                )}
                <DownloadVersion
                  compact
                  style={{ float: 'right', marginBottom: 10 }}
                  text={t('Download')}
                  bookId={submission.book._id}
                  content={submission.book.content}
                />
              </React.Fragment>
            );
          }
          return (
            <React.Fragment key={`bookRemoved ${submission.createdAt}`}>
              <hr />
              <h1>Book Removed</h1>
              <p style={{ marginBottom: 10 }}>
                {t('SubmittedBy', { _userName: submission.createdBy?.displayName })}
                <span style={{marginLeft: 8, color: 'var(--br-muted)'}}>
                  {moment(submission.createdAt).format('L LTS')}
                </span>
              </p>
              { submission.ranking && submission.ranking.eligibleForValentineCrime && (
                <p style={{marginBottom: 10, color: 'var(--br-success-text)'}}>
                  Valentine Crime Approved
                </p>
              )}
            </React.Fragment>
          );
        })
      }
  </div>
);

export default withTranslation()(ReceivedManuscriptsTabPane);
